"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _SaleTagFilled = require("../../../icons/SaleTagFilled");
var _promoMessagesModule = _interopRequireDefault(require("./promo-messages.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PromoMessages = function PromoMessages(_ref) {
  var _ref$promoMessages = _ref.promoMessages,
    promoMessages = _ref$promoMessages === void 0 ? [] : _ref$promoMessages,
    _ref$promoMessagesRef = _ref.promoMessagesRef,
    promoMessagesRef = _ref$promoMessagesRef === void 0 ? null : _ref$promoMessagesRef,
    _ref$isDior = _ref.isDior,
    isDior = _ref$isDior === void 0 ? false : _ref$isDior,
    _ref$hasTitle = _ref.hasTitle,
    hasTitle = _ref$hasTitle === void 0 ? true : _ref$hasTitle;
  if (!promoMessages || !promoMessages.length) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [hasTitle && /*#__PURE__*/(0, _jsxRuntime.jsxs)("h3", {
      ref: promoMessagesRef,
      className: (0, _classnames.default)(_promoMessagesModule.default.offers, _defineProperty({}, _promoMessagesModule.default['offers--dior'], isDior)),
      "data-testid": "qv-promo-messages",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SaleTagFilled.SaleTagFilled, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _promoMessagesModule.default.offerText,
        children: "Offers"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      className: _promoMessagesModule.default.offersList,
      children: promoMessages.map(function (offer, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          className: _promoMessagesModule.default.offersListItem,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: (0, _classnames.default)(_promoMessagesModule.default.promo, _defineProperty({}, _promoMessagesModule.default['promo--dior'], isDior)),
            "data-testid": "qv-promotion",
            children: offer
          }, offer)
        }, index);
      })
    })]
  });
};
PromoMessages.propTypes = {
  promoMessages: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(PromoMessages);